module.exports = __webpack_public_path__ + "img/brand-facebook.10555db2.svg";